export default {
  id: 227,
  title: 'Target #227 - Balanced',
  url: 'https://cssbattle.dev/play/227',
  colors: ['#CF6939', '#F9D081', '#123747', '#6D8971'],
  solution:
    '<p a><p b><style>body,p[b]{background:#cf6939}p{position:fixed;margin:0}p[a]{top:55;left:170;width:60;height:190;border-radius:1in;background:linear-gradient(#cf6939 80px,#123747 80px 160px,#6d8971 160px);box-shadow:0 0 0 40px #f9d081}p[b]{top:135;left:130;width:40;height:80;box-shadow:100px 0 #cf6939',
}
